// extracted by mini-css-extract-plugin
export default {"empty-box":"empty-box_YVOnS","emptyBox":"empty-box_YVOnS","icon":"icon_ofBsa","text":"text_D0lJI","fullscreen":"fullscreen_DQOME"};